export { AdminView } from "../../components/admin/admin-view";
